module.exports = false;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/_library.js
// module id = 515
// module chunks = 3